<template>
    <div class="field-filepickers field-wrap">
        <template v-for="n in maxCount">
            <app-filepicker
                v-bind:key="n"
                v-if="n === 1 || getProp(dataSource + '.image_' + (n - 2))"
                :label="label + ' #' + n"
                :data-source="dataSource + '.image_' + (n - 1)"
                :data-default="dataDefault"
                :file-namespace="fileNamespace"
                :accept="accept"
                :hideRemove="getProp(dataSource + '.image_' + n) ? true : false"
            ></app-filepicker>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    components: {
        'app-filepicker': Filepicker
    },
    computed: {
        ...mapGetters(['getProp'])
    },
    props: {
        label: String,
        dataSource: String,
        accept: String,
        showFocus: Boolean,
        showTransparency: Boolean,
        transparencyDefault: Number,
        maxCount: Number,
        dataDefault: Object,
        fileNamespace: String
    }
};
</script>
